import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import ErrorMessage from '../../components/ErrorMessage';
import LoadingOverlay from '../../components/LoadingOverlay';

import ErrorBoundary from '../../components/ErrorBoundary';
import CartTypeCheck from '../../components/CartTypeCheck';
import TransactionProgressCheck from '../../components/TransactionProgressCheck';

const Screens = ({ children }) => (
  <ErrorBoundary>
    <CartTypeCheck>
      <TransactionProgressCheck>
        <section className="screens flex flex-auto flex-column">
          <div className="overflow-hidden relative flex flex-auto flex-column">
            <div className="absolute w-100">
              <ErrorMessage />
            </div>
            <LoadingOverlay />
            <div className="pt2 pt4-m pt4-l w-100 measure-wide center flex flex-auto flex-column">
              {children}
            </div>
          </div>
        </section>
      </TransactionProgressCheck>
    </CartTypeCheck>
  </ErrorBoundary>
);

Screens.propTypes = {
  children: PropTypes.element.isRequired,
};

export default withRouter(Screens);
